/**
 * Resolve which folder-grid row should show the canvas-source cue.
 * ToolID on a sibling-method canvas icon matches the folder row ID.
 *
 * Does not expand or scroll. If the method row is collapsed, the nearest
 * displayed ancestor is used so a parent can pulse instead.
 */

export function resolveCanvasSourceHighlight(gridApi, toolId) {
    if (!toolId || !gridApi?.getRowNode)
        return null;

    const node = gridApi.getRowNode(toolId);
    if (!node)
        return null;

    if (node.displayed)
        return { id: toolId, role: 'source' };

    let walk = node.parent;
    while (walk) {
        const ancestorId = walk.data?.ID;
        if (ancestorId && walk.displayed)
            return { id: ancestorId, role: 'ancestor' };
        walk = walk.parent;
    }

    return null;
}
